import Vue from '@triotech/vue-core/src/vendor/vue';

const Roles = new Vue({
  computed: {
    PCIE: () => 'pcie',
    EVAL: () => 'eval',
  },
});

Vue.set(Vue.prototype, '$roles', Roles);

export default Roles;
